module.exports = __webpack_public_path__ + "static/synology-300x80-40ab01cd281ffe311feb9370be5de77b.png";